import { render, staticRenderFns } from "./ApproveApplicationItem.vue?vue&type=template&id=f9db358c&"
import script from "./ApproveApplicationItem.vue?vue&type=script&lang=js&"
export * from "./ApproveApplicationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports